import styled from 'styled-components';

const HeroStyle = styled.section`
	--contentDistance: var(--sp4x);
	--svgSize: var(--sp30x);
	--distanceTitleDescription: var(--sp6x);
	--padRightWrap: var(--sp30x);
	--radiusImage: var(--sp3x);
	--centerImageWidth: 58%;
	--rightImageSize: 27.7vw;
	--leftImageSize: 30vw;
	--centerImageSize: 18.3vw;
	--centerImageMR: var(--sp18x);
	--descWrapMBottom: var(--sp24x);

	padding: var(--contentDistance) var(--contPaddingLR) var(--sectionDistance);

	.hero-svg-block {
		display: flex;
		justify-content: center;
		padding-bottom: var(--distanceTitleDescription);

		canvas {
			width: var(--svgSize) !important;
			height: var(--svgSize) !important;
		}
	}

	.title-wrap {
		padding-bottom: var(--distanceTitleDescription);
	}

	.outside-wrapper {
		display: grid;
		grid-template-columns: 636fr 1206fr 604fr;
		grid-column-gap: var(--sp4x);
	}

	.wrap-outside-image {
		width: 100%;
		height: fit-content;
	}

	.image-cont {
		display: flex;
		border-radius: var(--radiusImage);
		background-color: transparent !important;
		transition: 0s ease-out !important;

		img {
			border-radius: var(--radiusImage);
			transition: 0s ease-out !important;
		}
	}

	.left-wrap {
		grid-area: 1/1/3/2;

		.image-cont {
			--proportion: var(--leftImageSize);
		}
	}

	.info-wrap {
		grid-area: 1/2/2/3;

		.title-wrap,
		.description-wrap {
			display: flex;
			align-items: center;
			justify-content: center;
		}

		.editor-wrapper {
			max-width: calc(100% * 4 / 6);
		}
	}

	.right-wrap {
		grid-area: 1/3/3/4;

		padding-bottom: var(--padRightWrap);

		.image-cont {
			--proportion: var(--rightImageSize);
		}
	}

	.center-wrap {
		grid-area: 2/2/3/3;
		display: flex;
		flex-direction: column;
		align-items: flex-end;

		.wrap-outside-image {
			width: var(--centerImageWidth);
			margin-right: var(--centerImageMR);
		}

		.image-cont {
			--proportion: var(--centerImageSize);
		}
	}
	.left-wrap {
		.wrap-outside-image {
			transform: translateY(100%);
		}
	}

	.right-wrap,
	.center-wrap {
		.wrap-outside-image {
			transform: translateY(100%);
		}
	}

	.left-wrap,
	.right-wrap {
		display: flex;
		align-items: flex-end;
	}

	.wrapper-styling-block {
		text-align: center;
	}

	.description-wrap {
		margin-bottom: var(--descWrapMBottom);
	}

	/* //! 1920 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXLMin}) {
		--contentDistance: var(--sp10x);
		--svgSize: var(--sp25x);
		--distanceTitleDescription: var(--sp5x);
		--padRightWrap: var(--sp21x);
		--radiusImage: var(--sp3x);
		--centerImageWidth: 54%;
		--rightImageSize: 27.2vw;
		--leftImageSize: 28vw;
		--centerImageSize: 16.7vw;
		--centerImageMR: var(--sp16x);
		--descWrapMBottom: var(--sp27x);
	}

	/* //! 1536 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeLMin}) {
		--contentDistance: var(--sp8x);
		--svgSize: var(--sp20x);
		--distanceTitleDescription: var(--sp4x);
		--padRightWrap: var(--sp16x);
		--radiusImage: var(--sp2x);
		--centerImageWidth: 54%;
		--rightImageSize: 27.2vw;
		--leftImageSize: 29.6vw;
		--centerImageSize: 16.7vw;
		--centerImageMR: var(--sp15x);
		--descWrapMBottom: var(--sp18x);
	}

	/* //! 1366 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeMMin}) {
		--contentDistance: var(--sp7x);
		--svgSize: var(--sp15x);
		--distanceTitleDescription: var(--sp3x);
		--padRightWrap: var(--sp17x);
		--radiusImage: var(--sp2x);
		--centerImageWidth: 54%;
		--rightImageSize: 27vw;
		--leftImageSize: 27.6vw;
		--centerImageSize: 16.7vw;
		--centerImageMR: var(--sp14x);
		--descWrapMBottom: var(--sp24x);

		.outside-wrapper {
			grid-template-columns: 3fr 6fr 3fr;
		}
	}

	/* //! 1280 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeSMin}) {
		--contentDistance: var(--sp7x);
		--svgSize: var(--sp15x);
		--distanceTitleDescription: var(--sp2-5x);
		--padRightWrap: var(--sp13x);
		--radiusImage: var(--sp1-5x);
		--centerImageWidth: 54%;
		--rightImageSize: 27vw;
		--leftImageSize: 27.6vw;
		--centerImageSize: 16.7vw;
		--centerImageMR: var(--sp13x);
		--descWrapMBottom: var(--sp16x);
	}

	/* //! 1024 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeMin}) {
		--contentDistance: var(--sp4x);
		--svgSize: var(--sp13x);
		--distanceTitleDescription: var(--sp2x);
		--padRightWrap: var(--sp9x);
		--radiusImage: var(--sp1-5x);
		--centerImageWidth: 54%;
		--rightImageSize: 26.3vw;
		--leftImageSize: 29vw;
		--centerImageSize: 16.5vw;
		--centerImageMR: var(--sp10x);
		--descWrapMBottom: var(--sp13x);

		.info-wrap {
			.editor-wrapper {
				max-width: 100%;
			}
		}
	}

	/* //! 768 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeXMin}) {
		--contentDistance: var(--sp5x);
		--svgSize: var(--sp13x);
		--distanceTitleDescription: var(--sp2x);
		--padRightWrap: var(--sp8x);
		--radiusImage: var(--sp1x);
		--centerImageWidth: 54%;
		--rightImageSize: 26.3vw;
		--leftImageSize: 28vw;
		--centerImageSize: 16.5vw;
		--centerImageMR: var(--sp7x);
		--descWrapMBottom: var(--sp8x);

		.outside-wrapper {
			grid-template-columns: 3fr 6fr 3fr;
		}
	}

	/* //! Mobile */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeSMin}) {
		--contentDistance: var(--sp4x);
		--svgSize: var(--sp11x);
		--distanceTitleDescription: var(--sp2x);
		--padRightWrap: 0px;
		--centerImageMR: 0px;

		--radiusImage: var(--sp1x);
		--centerImageWidth: 49%;
		--rightImageSize: 47.3vw;
		--leftImageSize: 57vw;
		--centerImageSize: 30.5vw;

		--descWrapMBottom: 0;

		.center-wrap {
			align-items: center;
			position: relative;
			padding-top: var(--sp4x);
		}

		.outside-wrapper {
			grid-template-columns: 175fr 149fr;
			grid-column-gap: var(--sp2-5x);
		}

		.info-wrap {
			grid-area: 1/1/2/3;
		}

		.left-wrap {
			grid-area: 2/1/3/2;
			padding-top: var(--sp6x);
		}

		.right-wrap {
			align-items: flex-start;
			grid-area: 2/2/3/3;
		}

		.center-wrap {
			grid-area: 3/1/4/3;
		}

		.description-wrap {
			padding-bottom: var(--sp4x);
		}
	}
`;

export default HeroStyle;
